// Package Imports
// import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loading from 'components/loading/loading';
import PrivateRouteConst from 'core/common/privateRouteConstant';

const NudgeConfiguration = lazy(
  () => import('pages/nudgeConfiguration/nudgeConfiguration')
);
const NudgeConfigurationCreate = lazy(
  () => import('pages/nudgeConfiguration/nudgeConfigurationCreate')
);
const NudgeConfigurationShow = lazy(
  () => import('pages/nudgeConfiguration/nudgeConfigurationShow')
);
const NudgeConfigurationEdit = lazy(
  () => import('pages/nudgeConfiguration/nudgeConfigurationEdit')
);

const NudgeConfigurationRoute = (
  <Route path={routeName.nudgeConfiguration}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.NUDGE_CONFIGURATION_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <NudgeConfiguration />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.NUDGE_CONFIGURATION_CREATE}>
          <Suspense fallback={<Loading />}>
            <NudgeConfigurationCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.NUDGE_CONFIGURATION_EDIT,
            PrivateRouteConst.SELF_NUDGE_CONFIGURATION_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <NudgeConfigurationEdit />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.NUDGE_CONFIGURATION_VIEW,
            PrivateRouteConst.SELF_NUDGE_CONFIGURATION_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <NudgeConfigurationShow />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default NudgeConfigurationRoute;
